/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { formatAmount } from '../../../../services/helpers';
import { StyledAlertPaymenButton, StyledAlertPaymentPix, StyledAlertPaymentPixContent, StyledAlertPixContainer } from './styles';
import {
    Redirect,
    Link
} from 'react-router-dom';
import { socket } from '../../../../services/socket';

export function AlertPaymentPix() {
    const [statusPayment, setPaymentStatus] = useState("")
    // const [isEmmitedSocket, setIsEmmitedSocket] = useState(false);
    const [pixData, setPixData] = useState([])
    const clientInfo = JSON.parse(localStorage.getItem('clientInfo'));

    useEffect(() => {
        let initial = true;

        if (clientInfo.number && clientInfo.number !== '' && initial) {
            socket.emit("pix-server-app-transactions", {
                msisdn: clientInfo.number,
                // rechargeMsisdn: clientInfo.number,
            });
        }
        return () => {
            initial = false;
        }

    }, [clientInfo.number]);


    socket.on("pix-client", (data) => {
        if (data.status === "P00" || data.status === "P01") {
          setPaymentStatus("Pago");
        }
        console.log('pix-clinte alert', data);
        setPixData(data);
    
        if (data.lenght !== 0) {
          localStorage.setItem("@pix-data", JSON.stringify(data));
        }
        // socket.disconnect();

        // const newPixData = {
        //     ...data,
        //     pixExpirationDate: "2022-03-15T06:01:01.799Z"
        // }

        const currentTime = new Date();
        const hasExpiredPixDate =
            new Date(pixData.pixExpirationDate) < currentTime;

        if (data && hasExpiredPixDate) {
            localStorage.removeItem('@pix-data');
            setPaymentStatus("Expired")
        }
      });


    // if (statusPayment !== "Pago" && pixData.length !== 0 && pixData.message === "Pending") {
    if (pixData && 
        pixData.message === "Pedding" && 
        pixData.value !== "" &&
        pixData.value !== undefined && 
        statusPayment === "") {
        return (
            <StyledAlertPixContainer >
                <StyledAlertPaymentPix>
                    <StyledAlertPaymentPixContent>
                        Atenção! Sua recarga de {formatAmount(pixData.value)} foi realizada e está com pagamento pendente,
                        por favor realize o pagamento
                    </StyledAlertPaymentPixContent>
                    <Link to="/recarga" onClick={() => {
                        localStorage.setItem('@pix-data-recharge', JSON.stringify('true'))
                    }}>
                        <StyledAlertPaymenButton >
                            Pagar agora
                        </StyledAlertPaymenButton>
                    </Link>
                </StyledAlertPaymentPix>
            </StyledAlertPixContainer>
        );
    }

    return null;

}
